let bottom = {
  contactUS: "Contact Us",
  followUS: "Follow us",
  product: {
    title: "Product Purchase",
    dynamic: "dynamic house",
    data: "data center",
    mobile: "mobile agent"
  },
  howToUse: {
    title: "How to use",
    extract: "Extract API",
    ledger: "Ledger API",
    browser: "browser plugin"
  },
  applications: {
    title: "My Applications",
    href: "brand protection",
    eCommerce: "e-commerce",
    website: "website test",
    social: "social media",
    seo: "SEO optimization",
    price: "price comparison",
    ad: "Ad Verification",
    mail: "mail protection",
    market: "market survey"
  },
  resource: {
    title: "Resource Center",
    problem: "Common problem",
    document: "Product Documentation",
    api: "Public API"
  },
  legal: {
    title: "Legal",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy"
  }
}

export default bottom


// WEBPACK FOOTER //
// ./src/assets/lang/en/bottom/index.js